import webridge from "./webridge";
import { CODE } from "./constant";
import _ from 'lodash'

/**
 * 异步调用Native方法
 * @param bad myUserInfo的兼容处理，不好的方式，客户端在1.0.62版本已修改，逐步移除
 */
export function callNativeMethodAsync(method, data, timeout = 500, bad = false) {
  return new Promise((resolve, reject) => {
    try {
      let i = 0;
      let timer = null;
      let isError = false;
      webridge.callNativeMethod(method, data, function(response) {
        if (response && typeof response === "string") {
          try {
            if (bad) {
              response = _.replace(response, new RegExp(",\"photoWall\":\"\\[\".*\"\\]\"", "g"), "")
            }
            response = JSON.parse(response);
          } catch (e) {
            reject(e);
          }
        }
        if (response && response.code === CODE.SUCCESS) {
          clearInterval(timer);
          resolve(response.data);
        } else {
          isError = true;
          reject(new Error(response.message));
        }
      });
      if (timeout && timeout > 0) {
        timer = setInterval(() => {
          if (i > timeout / 100) {
            if (isError) {
              clearInterval(timer);
              return;
            }
            reject(new Error(`callNativeMethodAsync:${method} timeout`));
            clearInterval(timer);
            return;
          }
          i++;
        }, 100);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function addNativeMessageListener(messageType, cb) {
  window[messageType] = cb;
}

export function removeNativeMessageListener(messageType) {
  window[messageType] = null;
}